export default __webpack_public_path__ + "static/media/Layer 331.7220a158.jpg";